import { GtmStatsObserver } from './observer';
import { GtmStatsTrackerFactory } from './tracker.factory';

export function GtmStatsObserverFactory(): GtmStatsObserver {
  return new GtmStatsObserver(GtmStatsTrackerFactory());
}
